export default "__VITE_ASSET__Bcc$vVeg__"